import { Button, ButtonInterface } from '../button';
import { get } from 'lodash';

interface EmptyInterface {
  size: 'xs' | 'sm' | 'md' | 'lg';
  title: string;
  subtitle?: string;
  actions: ButtonInterface[];
  children: ReactNode[];
}

const fontSize = {
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-md',
  lg: 'text-lg'
};

const spacing = {
  xs: 'space-y-2 p-2',
  sm: 'space-y-2 p-2',
  md: 'space-y-4 p-4',
  lg: 'space-y-6 p-6'
};

export function Empty({
  title,
  subtitle,
  actions = [],
  minHeight = 'h-[400px]',
  size = 'md',
  children
}: EmptyInterface) {
  return (
    <div
      className={`border-dashed border rounded-lg border-slate-200 flex items-center justify-center ${minHeight}`}
    >
      <div className={`text-center flex flex-col ${spacing[size]}`}>
        <h3 className={`px-4 font-hmedium text-slate-600 ${fontSize[size]}`}>{title}</h3>
        {subtitle && <p className="text-slate-400">{subtitle}</p>}
        {children}
        {actions.length > 0 && (
          <div>
            {actions.map((act, index) => {
              const component = get(act, 'component');
              if (component) {
                return <div key={index}>{component}</div>;
              } else {
                return <Button key={index} {...act} size={act.size || size} />;
              }
            })}
          </div>
        )}
      </div>
    </div>
  );
}
